import {findMany, find, offset, on, off, removeClass, addClass} from '../helpers'

findMany('details').forEach(container => {
    const title = find('summary', container)
    const bodyCopy = find('[data-accordion]', container)

    let garbageCollection

    const open = () => {
        requestAnimationFrame(() => {
            const { height } = offset(bodyCopy)

            bodyCopy.style.height = 0

            requestAnimationFrame(() => {
                bodyCopy.style.height = `${height}px`
            })
        })
    }

    const resetHeight = () => {
        container.open = false
        bodyCopy.style.height = 'auto'

        removeClass(container, 'closing')

        off('transitionend', resetHeight, bodyCopy)

        clearTimeout(garbageCollection)
    }

    const close = event => {
        event.preventDefault()

        addClass(container, 'closing')

        const { height } = offset(bodyCopy)

        bodyCopy.style.height = `${height}px`

        on('transitionend', resetHeight, bodyCopy)

        clearTimeout(garbageCollection)
        garbageCollection = setTimeout(resetHeight, 1000)

        requestAnimationFrame(() => {
            bodyCopy.style.height = 0
        })
    }

    // Had to create a new method but replicate some of the above to allow others to close correctly
    const openSingular = () => {
        const openAccordions = findMany('details[data-single-open][open]')

        openAccordions.forEach(detail => {
            const bodyCopy = find('[data-accordion]', detail);

            const resetsHeight = () => {
                detail.open = false
                bodyCopy.style.height = 'auto'

                removeClass(detail, 'closing')

                off('transitionend', resetsHeight, bodyCopy)

                clearTimeout(garbageCollection)
            }

            if (detail !== container) {
                addClass(detail, 'closing')

                const { height } = offset(bodyCopy)

                bodyCopy.style.height = `${height}px`

                on('transitionend', resetsHeight, bodyCopy)

                clearTimeout(garbageCollection)
                garbageCollection = setTimeout(resetsHeight, 1000)

                requestAnimationFrame(() => {
                    bodyCopy.style.height = 0
                })
            }
        })

        open()
    }

    title.addEventListener('click', e => container.open ? close(e) : (container.hasAttribute(['data-single-open']) ? openSingular() : open()))
});
